<template>
  <el-dialog
    :title="formTitle"
    :visible.sync="isVisible"
    custom-class="dialog-short-form"
    class="dialog-companies-form"
    :class="{'is-edit-mode': isEditMode, 'is-new': state === 'new'}"
    :closeOnClickModal="false"
    append-to-body
    @close="setQuery">
    <div class="companies-form-content" v-loading="isLoading">
      <form-companies
        :data="data"
        :model="formModel"
        @change="handleFormData"
        ref="Form"/>
      <form-controls
        class="form-footer"
        isCancel
        :isCreate="!hasCreateNew"
        @command="setCommand"/>
    </div>
  </el-dialog>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { api } from '@/services/api'

export default {
  name: 'ModalNewDetail',
  mixins: [FormWrapper],
  components: {
    'form-companies': () => import(/* webpackChunkName: 'Companies' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    config: { type: Object }
  },
  computed: {
    formTitle () {
      return this.formData.title || this.checkEs6AndRun(this.title)
    }
  },
  methods: {
    formModel () {
      return {
        id: null,
        name: ''
      }
    },
    save () {
      if (!this.$refs.Form) {
        return console.error('not found form')
      }
      this.isLoading = true
      this.$refs.Form.validate()
        .then(() => {
          return this.requestCreate()
        })
        .then(response => {
          this.gridCreateHandler(response)
        })
        .catch(error => {
          this.gridCreateHandler(error)
        })
    },
    handleEndCreateAndPath (Data, isEditAfter = false) {
      this.setQuery()
      requestAnimationFrame(() => {
        this.$emit('creatSuccess', Data)
      })
    },
    handlePrepareData (Data) {
      delete Data.id
      return Data
    },
    requestCreate () {
      return api
        .post(`Companies/Create`, this.handlePrepareData(this.$refs.Form.getData()))
    }
  }
}
</script>

<style lang="stylus">
  .details-form-content{
    .el-form-item.material-style{
      margin 2.4rem 0 0
    }
  }
</style>
